/* v1 ============================================================
   LCS — Encounters gate
   - Estado persistido en localStorage: lcs-encounters-access = 'true'/'false'
   - Email signup → muestra hint de la clave
   - Validación de clave LCS2026 → desbloquea grid
   - Logout → vuelve al gate
   - TODO: integrar Klaviyo (POST /api/profiles/) cuando esté el API key
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-encounters]');
  if (!root) return;

  const MAGIC_KEY = 'LCS2026';
  const ACCESS_KEY = 'lcs-encounters-access';
  const MAILING_KEY = 'lcs-mailing-list';

  const gate     = root.querySelector('[data-encounters-gate]');
  const unlocked = root.querySelector('[data-encounters-unlocked]');
  const stepEmail = root.querySelector('[data-step="email"]');
  const stepKey   = root.querySelector('[data-step="key"]');
  const errorBox  = root.querySelector('[data-encounters-error]');
  const sentEmail = root.querySelector('[data-encounters-sent-email]');
  const formEmail = root.querySelector('[data-encounters-form-email]');
  const formKey   = root.querySelector('[data-encounters-form-key]');
  const logoutBtn = root.querySelector('[data-encounters-logout]');

  function showError(msg) {
    if (errorBox) {
      errorBox.textContent = msg;
      errorBox.hidden = !msg;
    }
  }

  function showState(state) {
    // state: 'gate-email' | 'gate-key' | 'unlocked'
    if (state === 'unlocked') {
      if (gate)     gate.hidden = true;
      if (unlocked) unlocked.hidden = false;
      return;
    }
    if (gate)     gate.hidden = false;
    if (unlocked) unlocked.hidden = true;
    if (stepEmail) stepEmail.hidden = state !== 'gate-email';
    if (stepKey)   stepKey.hidden   = state !== 'gate-key';
    showError('');
  }

  // ---- Estado inicial ----
  let hasAccess = false;
  try { hasAccess = localStorage.getItem(ACCESS_KEY) === 'true'; } catch (e) {}
  showState(hasAccess ? 'unlocked' : 'gate-email');

  // ---- Email signup ----
  if (formEmail) {
    formEmail.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = formEmail.querySelector('input[type="email"]');
      const email = (input && input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError('ingresa un email válido');
        return;
      }
      // Guardar email localmente (placeholder de Klaviyo).
      try {
        const list = JSON.parse(localStorage.getItem(MAILING_KEY) || '[]');
        if (!list.includes(email)) {
          list.push(email);
          localStorage.setItem(MAILING_KEY, JSON.stringify(list));
        }
      } catch (e) {}
      // TODO Klaviyo: POST a /api/profiles/ cuando esté configurado.

      // Mostrar el step de la clave + el email confirmado
      if (sentEmail) sentEmail.textContent = email;
      showState('gate-key');
    });
  }

  // ---- Validación de clave ----
  if (formKey) {
    formKey.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = formKey.querySelector('input[type="text"]');
      const key = (input && input.value || '').trim().toUpperCase();
      if (key === MAGIC_KEY) {
        try { localStorage.setItem(ACCESS_KEY, 'true'); } catch (e) {}
        showState('unlocked');
      } else {
        showError('clave incorrecta. intenta de nuevo.');
      }
    });
  }

  // ---- Logout ----
  if (logoutBtn) {
    logoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      try { localStorage.setItem(ACCESS_KEY, 'false'); } catch (e) {}
      // Reset campos
      if (formEmail) formEmail.reset();
      if (formKey)   formKey.reset();
      showState('gate-email');
    });
  }
})();
